import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalLoginComponent } from 'src/app/components/modals/modal-login/modal-login.component';
import { ScaModalComponent } from 'src/app/components/modals/sca-modal/sca-modal.component';
import { CommonsService } from 'src/app/services/commons.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { EntitiesService } from 'src/app/services/entities.service';
import { Router } from '@angular/router';
import { CONSTANTS } from '../../shared/constants';
import { trigger, style, animate, transition } from '@angular/animations';
import { WarningTermsPolityComponent } from 'src/app/components/modals/warning-terms-polity/warning-terms-polity.component';
import { WarningLoginComponent } from 'src/app/components/modals/warning-login/warning-login.component';


declare var $: any;
@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  animations: [
    trigger('fade', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate(1300, style({ opacity: 1 }))
      ])
    ])
  ]
})
export class LoginComponent implements OnInit {

  nextTab = 0;
  entities: any;
  mainEntities: any;
  ent: any;
  loginForm: UntypedFormGroup;
  show = false;
  showError = false;
  hiddeLabel = true;
  nameCredentials = [];
  formatInvalid = false;
  autenticationFalse = false;
  limitedExceded = false;
  minus: any;
  showIcon: any = 1;
  country: string;
  token: string;
  bankSelected: string;
  headerFooter: boolean;
  data: any;
  backButtonShow = true;
  refreshEntityCode = true;
  warningModalConfig = new MatDialogConfig();
  contratacion: boolean;

  constructor(private readonly modal: MatDialog,
    private readonly c: CommonsService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly entitesService: EntitiesService,
    private readonly route: Router, 
    private se: EntitiesService) {
    this.backButtonShow = !sessionStorage.getItem('refreshEntityCode');
  }

  ngOnInit() {
    this.contratacion = !!JSON.parse(sessionStorage.getItem('getParams'));
    this.c.reloadOTBanner();
    this.c.clearDup();
    this.c.firstChargePage('Login', 'Seleccion de entidad', 'funnel');
    this.c.eventsAnalitics('visit screen', 'Seleccion de bancos', 'login');
    this.loginForm = this.formBuilder.group({}, {});
    this.optionCharge();
    this.showIconConsumer();
    this.warningModalConfig.width = '320px';
    this.warningModalConfig.id = 'modal-info';
    this.warningModalConfig.maxWidth = '500px';
    this.country = sessionStorage.getItem('country') || 'ES';
  }

  /**
   * Carga de datos segun demanda (F5 sobre login o traer datos desde la vista anterior)
   */
  optionCharge() {
    const e = sessionStorage.getItem('refreshEntityCode');
    this.refreshEntityCode = e ? false : true;
    if (e) { // if si existe un entityCode para actualizar la entidad----------------
      const st = sessionStorage.getItem('banksEntities');
      setTimeout(() => {
        if (st || this.c.getEnt()) {
          this.entities = (st) ? JSON.parse(st) : this.c.getEnt();
          this.mainEntities = this.entities.slice(0, 6);
          this.nextTab = 1;
          //this.nextStep(e);
        } else {
          this.entitesService.getEntities(sessionStorage.getItem('t')).subscribe(data => {
            sessionStorage.setItem('banksEntities', JSON.stringify(data.banks));
            this.entities = data.banks;
            this.mainEntities = data.banks.slice(0, 6);
            this.nextTab = 1;
            //this.nextStep(e);
          }, error => {
            if (error) {
              this.route.navigateByUrl('/signin');
            }
          });
        }
      }, 100);

    } else { // -------------------------Fin de entrada refresh-----------------------------------
      this.getEntities();
    }
  }

  getEntities() {
    if (this.c.getEnt()) {
      this.entities = this.c.getEnt();
      this.mainEntities = this.entities.slice(0, 6);
    } else {
      this.entitesService.getEntities(sessionStorage.getItem('t')).subscribe(data => {
        this.entities = data.banks;
        this.mainEntities = data.banks.slice(0, 6);
      }, error => {
        if (error) {
          this.route.navigateByUrl('/terms');
        }
      });
    }
  }

  showIconConsumer() {
    const v = JSON.parse(sessionStorage.getItem('getParams'));
    this.showIcon = v ? v[0] : 1;
    if (v) {
      this.headerFooter = v[0] !== '3';
    } else {
      this.headerFooter = true;
    }
  }

  /**
   * restaura el proceso de cambio entre tabs
   * @param val: number
   */
  backTab() {
    if (this.nextTab === 0) {
      return;
    }
    this.loginForm.reset();
    this.nextTab = 0;
    this.hiddeLabel = true;
    this.formatInvalid = false;
    this.c.eventsAnalitics('click', 'Atras', this.bankSelected);
  }

  /**
   * pasa al siguiente tab
   * @param position: number
   * @param bankId: string
   */
  nextStep(bankId) {
    this.bankSelected = this.c.getNameEntity(bankId);
    sessionStorage.setItem('bankCode', bankId);
    this.ent = this.entities.filter(data => data.BankId === bankId)[0] || this.entities.filter(data => data.Name === this.bankSelected)[0];
    this.nameCredentials = [];
    for (const key of this.ent.Params) {
      this.nameCredentials.push(key.name);
    }
    this.nextTab = 1;
    this.c.eventsAnalitics('click', 'Selección de banco', this.bankSelected);
    this.addCustomForm(this.ent);
  }

  getBankLink(d){
    this.token = sessionStorage.getItem('t')
    this.se.getBankLink(this.token, d, this.country).subscribe(data => window.location.href = data);
  }


  findImg(bankId) {
    const entity = CONSTANTS.entities.filter(data => data.code === bankId)[0];
    return (entity) ? entity.code : false;
  }

  /**
   * abre modal informacion
   */
  openModal(): void {
    this.c.eventsAnalitics('click', 'Abrir modal de información', '/login');
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.data = { rapidScore: this.contratacion}
    modalConfig.id = 'modal-info-rapidScore';
    modalConfig.maxWidth = '500px';
    this.modal.open(ModalLoginComponent, modalConfig);
  }

  saveUrl() {
    this.c.setCurrentUrl(this.route.url);
    this.c.eventsAnalitics('click', 'FAQs', '/login');
    this.route.navigateByUrl('faqs');
  }

  /**
   * levanta el loading component
   */
  showLoading() {
    if (this.loginForm.valid) {
      this.data = {};
      this.data = {
        token: sessionStorage.getItem('t'),
        BankCode: this.ent.BankId,
        credentials: []
      };

      let cont = 0;
      const valuesControls = this.loginForm.controls;

      // tslint:disable-next-line: forin
      for (const key in valuesControls) {
        this.data.credentials.push({
          name: this.nameCredentials[cont++],
          value: this.loginForm.get(key).value
        });
      }
      this.show = true;
      const params = JSON.parse(sessionStorage.getItem('getParams')) || ['1'];
      this.selectLogin(params);
    }
  }


  selectLogin(params) {
    this.autenticationFalse = false;
    this.c.eventsAnalitics('click', 'Confirmación de banco', this.bankSelected);
    switch (params[0]) {
      case '1':
      case '2':
        this.entitesService.connectToEntity(this.data).subscribe(d => {
          this.postAggretation(this.formatKPIs(d));
        }, error => {
          this.show = false;
          this.showError = true;
        });
        break;

      case '4':
      case '3':
        this.entitesService.connectToEntity(this.data, params[0]).subscribe(d => {
          this.show = false;
          if (d.Code === 409) {
            this.c.setServiceSCA((d.SCA) ? d.SCA : null);
            sessionStorage.setItem('t', d.Token);
            this.openSCAModal();
            return;
          }
          if (d.resultEA && d.resultEA.message) {
            this.warningModalConfig.data = { text: d.resultEA.message };
            this.modal.open(WarningLoginComponent, this.warningModalConfig);
            return;
          }
          if (d.Code === 401) {
            this.autenticationFalse = true;
            return;
          } else if (d.Code === 403) {
            this.showError = true;
            return;
          }
          this.route.navigateByUrl('engagement');
          sessionStorage.setItem('t', d.Token);
          sessionStorage.setItem('_k', this.c.encrypt(d));
          this.c.setKpi(d);
        }, error => {
          this.show = false;
          this.showError = true;
        });
        break;
    }
  }

  /**
   * compruena la respuesta del servicio y levanta modal
   * @param code: number
   * @param sca: object
   */
  postAggretation(d) {
    this.show = false;
    this.autenticationFalse = false;
    this.limitedExceded = false;
    if (d.resultEA && d.resultEA.message) {
      this.warningModalConfig.data = { text: d.resultEA.message };
      this.modal.open(WarningLoginComponent, this.warningModalConfig);
      return;
    }
    if (d.Code === 403) {
      this.showError = true;
    } else if (d.Code === 200) {
      sessionStorage.removeItem('_k');
      sessionStorage.setItem('_k', this.c.encrypt(d));
      this.c.setKpi(d);
      this.c.eventsAnalitics('conversion', 'Cuenta agregada', this.bankSelected);
      sessionStorage.removeItem('gs');
      sessionStorage.removeItem('bankCode');
      sessionStorage.removeItem('banksEntities');
      sessionStorage.removeItem('refreshEntityCode');
      sessionStorage.removeItem('Channel');
      this.route.navigateByUrl('global-position');
    } else if (d.Code === 409) {
      this.c.setServiceSCA((d.SCA) ? d.SCA : null);
      sessionStorage.setItem('t', d.Token);
      this.openSCAModal();
    } else if (d.Code === 303) { // -------------------------------------------------- ING
      d.SCA = {
        description: d.Message
      };
      d.description = d.Message;
      this.c.setServiceSCA(d.SCA);
      sessionStorage.setItem('t', d.Token);
      this.openSCAModal();
    } else if (d.Code === 401) {
      this.autenticationFalse = true;
    } else if (d.Code === 406) {
      this.limitedExceded = true;
    }
  }

  openSCAModal() {
    const modalConfig = new MatDialogConfig();
    modalConfig.width = '90%';
    modalConfig.id = 'modal-sca';
    modalConfig.maxWidth = '62vw';
    modalConfig.disableClose = true;
    modalConfig.data = {isRapidScore: this.contratacion}
    this.show = false;
    const closedModal = this.modal.open(ScaModalComponent, modalConfig);
    closedModal.afterClosed().subscribe(result => {
      const params = JSON.parse(sessionStorage.getItem('getParams')) || ['1'];
      result['channel'] = params[0];
      if (result) {
        this.show = true;
        this.entitesService.connectToEntitySCA(result).subscribe(d => {
          if (CONSTANTS.getChannels(params[0])) {
            if (d.resultEA && d.resultEA.message) {
              this.warningModalConfig.data = { text: d.resultEA.message };
              this.modal.open(WarningLoginComponent, this.warningModalConfig);
            }
            if (d.Code === 200) {
              this.route.navigateByUrl('engagement');
              sessionStorage.setItem('t', d.Token);
              sessionStorage.setItem('_k', this.c.encrypt(d));
              this.c.setKpi(d);
            } else {
              this.show = false;
            }
          } else {
            this.c.eventsAnalitics('click', 'Verificación paso 2', this.bankSelected);
            this.postAggretation(this.formatKPIs(d));
          }
        }, error => {
          this.show = false;
          this.showError = true;
        });
      }
    });
  }


  formatKPIs(d) {
    d.kpis = [];
    if (d.score.CategoryScore) {
      d.score.CategoryScore.forEach(a => {
        a.CategoryKpiList.forEach(b => d.kpis.push(b));
      });
    }
    return d;
  }


  /**
   * Devuelve el tipo de input que se imprimira, text o password
   * @param accessMethod: string
   */
  printPassword(accessMethod: string) {
    const method = accessMethod.toLowerCase();

    if (method.includes('clave') || method.includes('pin') || method.includes('password') || method.includes('contraseña') ||
      method.includes('secreto')) {
      return 'password';
    } else {
      return 'text';
    }
  }

  /**
   * resetea el campo DNI/passaporte/tarjeta residente con ING
   * @param entity: string
   */
  resetUser(entity) {
    if (entity === 'ING') {
      this.loginForm.get('user').setValue('');
    } else {

    }
  }

  disableDragging(event) {
    event.preventDefault();
  }

  goToHome(check) {
    if (!check) {
      return;
    }
    this.route.navigateByUrl('/home');
  }


  /**
   * genera dinamicamente un formulario en funcion de los campos por cada entidad
   * @param entity: string
   */
  private addCustomForm(entity) {
    this.loginForm = this.formBuilder.group({}, {});
    this.addNewValidationBank(entity);
    this.nextTab = 1;
  }

  /**
   * añade formControls de manera dinamica
   * @param entity: any
   */
  private addNewValidationBank(entity: any) {
    if (entity.BankId !== '1465') {
      for (const iterator of entity.Params) {
        if ((iterator.Description.includes('Tipo de Documento') ||
          iterator.Description.includes('Código Identificación Usuario o DNI (sin letra)')) && iterator.ParamsValue && iterator.ParamsValue.length) {
          this.loginForm.addControl('select', new UntypedFormControl('', [Validators.required]));
        } else {
          this.loginForm.addControl(iterator.Description, new UntypedFormControl('', [Validators.required]));
          if ((iterator.Description.toLowerCase().includes('dni') || iterator.Description.toLowerCase().includes('nif')
            || iterator.Description.toLowerCase().includes('documento'))) {
            if (entity.BankId === '0049') {
              this.checkDniSantanderOpenbank('Usuario/Número de documento');
            } else if (entity.BankId === '0073') {
              this.checkDniSantanderOpenbank(iterator.Description);
            } else if (entity.BankId === '2085') {
              this.checkNoLetterDni(iterator.Description);
            } else {
              this.checkGenerickDni(iterator.Description);
            }
          }
        }
      }
    } else {
      this.formIng(entity);
    }

  }

  /**
   * Formar el formulario de ING
   */
  private formIng(data) {
    for (const i of data.Params) {
      if (i.ParamsValue.length > 0) {
        this.loginForm.addControl('select', new UntypedFormControl('', [Validators.required]));
      }
    }

    this.loginForm.addControl('user', new UntypedFormControl('', [Validators.required]));
    this.loginForm.addControl('day', new UntypedFormControl('', [Validators.max(31), Validators.required]));
    this.loginForm.addControl('month', new UntypedFormControl('', [Validators.max(12), Validators.required]));
    this.loginForm.addControl('year', new UntypedFormControl('', [Validators.min(1900), Validators.max(new Date().getFullYear()),
    Validators.required]));
    this.loginForm.addControl('key', new UntypedFormControl('', [Validators.minLength(6), Validators.required]));
    this.dniAndPassportING('user');
    this.dateIng();
  }

  /**
   * comprueba que no se introducen valores irreales
   */
  private dateIng() {
    this.loginForm.valueChanges.subscribe(d => {
      if (d.day && d.month && d.year && CONSTANTS.dayMonths(+d.day, +d.month)) {
        this.loginForm.setErrors({ wrongDay: true });
      } else if (d.day && d.month && d.year && !CONSTANTS.dayMonths(+d.day, +d.month)) {
        this.loginForm.setErrors(null);
      }
    });
  }

  /**
   * sirve para verificar DNI y pasaporte
   * @param key: string
   */
  private checkGenerickDni(key) {
    const letras = 'TRWAGMYFPDXBNJZSQVHLCKET';
    this.loginForm.get(key).valueChanges.subscribe(d => {
      this.autenticationFalse = false;
      this.loginForm.get(key).setErrors(null);
      if (!d) {
        return;
      }
      if (/^(\d{8})([A-Za-z])$/.test(d)) {
        if (letras.split('')[+d.substring(0, 8) % 23].toLowerCase() === d.split('')[d.length - 1].toLowerCase()) {
          this.loginForm.get(key).setErrors(null);
          this.formatInvalid = false;
        } else {
          this.loginForm.get(key).setErrors({ dni: false });
          this.formatInvalid = true;
        }
      } else if (/^([ABCDEFGHJKLMNPQRSUVWabcdefghjklmnpqrsuvw])(\d{7})([0-9A-Ja-j])$/.test(d.toLowerCase())) {
        this.formatInvalid = false;
        this.loginForm.get(key).setErrors(null);
      } else if (/^[XYZxyz]\d{7,8}[A-Za-z]$/.test(d.toLowerCase())) {
        this.loginForm.get(key).setErrors(null);
        this.formatInvalid = false;
      } else {
        this.formatInvalid = true;
        this.loginForm.get(key).setErrors({ dni: false });
      }
    });
  }

  private checkNoLetterDni(key) {
    this.loginForm.get(key).valueChanges.subscribe(d => {
      this.autenticationFalse = false;
      this.loginForm.get(key).setErrors(null);
      if (!d) {
        return;
      }
      this.loginForm.get(key).setErrors(null);
      this.formatInvalid = false;
    });
  }

  private dniAndPassportING(key) {
    const letras = 'TRWAGMYFPDXBNJZSQVHLCKET';
    this.loginForm.get(key).valueChanges.subscribe(d => {
      this.autenticationFalse = false;
      this.loginForm.get(key).setErrors(null);
      if (!d) {
        this.loginForm.get(key).setErrors({ dni: false });
        return;
      }
      if (this.loginForm.get('select')) {
        const value = this.loginForm.get('select').value;
        if (+value === 0 || +value === 2) {
          if (/^(\d{8})([A-Za-z])$/.test(d)) { // tarjeta residente, DNI o NIF
            if (letras.split('')[+d.substring(0, 8) % 23].toLowerCase() === d.split('')[d.length - 1].toLowerCase()) {
              this.loginForm.get(key).setErrors(null);
              this.formatInvalid = false;
            } else {
              this.loginForm.get(key).setErrors({ dni: false });
              this.formatInvalid = true;
            }
          } else {
            this.loginForm.get(key).setErrors({ dni: false });
            this.formatInvalid = true;
          }
        } else { // pasaporte
          if (/^[A-Za-z]{3}[0-9]{6}[A-Za-z]?$/i.test(d.toLowerCase())) {
            this.loginForm.get(key).setErrors(null);
            this.formatInvalid = false;
          } else {
            this.loginForm.get(key).setErrors({ passport: false });
            this.formatInvalid = true;
          }
        }
      } else {
        this.onlySelect(key, letras, d);
      }
    });
  }

  private onlySelect(key, letras, d) {
    if (/^(\d{8})([A-Za-z])$/.test(d)) { // tarjeta residente, DNI o NIF
      if (letras.split('')[+d.substring(0, 8) % 23].toLowerCase() === d.split('')[d.length - 1].toLowerCase()) {
        this.loginForm.get(key).setErrors(null);
        this.formatInvalid = false;
      } else {
        this.loginForm.get(key).setErrors({ dni: false });
        this.formatInvalid = true;
      }
    } else {
      this.loginForm.get(key).setErrors({ dni: false });
      this.formatInvalid = true;
    }

  }

  private checkDniSantanderOpenbank(input) {
    const doc = input;
    const type = 'select';
    const letras = 'TRWAGMYFPDXBNJZSQVHLCKET';

    this.loginForm.valueChanges.subscribe(d => {
      this.autenticationFalse = false;
      this.loginForm.setErrors(null);
      if (!d) {
        return;
      }
      switch (d[type]) {
        case 'C':
          if (d[doc] && /^([ABCDEFGHJKLMNPQRSUVWabcdefghjklmnpqrsuvw])(\d{7})([0-9A-Ja-j])$/.test(d[doc].toLowerCase())) {
            this.loginForm.setErrors(null);
            this.formatInvalid = false;
          } else {
            this.loginForm.setErrors({ formatNotValid: true });
            this.formatInvalid = true;
          }
          break;
        case 'P':
        case 'PAS':
          if (d[doc] && /^[A-Za-z]{3}[0-9]{6}[A-Za-z]?$/i.test(d[doc].toLowerCase())) {
            this.loginForm.setErrors(null);
            this.formatInvalid = false;
          } else {
            this.loginForm.setErrors({ formatNotValid: true });
            this.formatInvalid = true;
          }
          break;
        case 'E':
          if (d[doc] && /^[XYZxyz]\d{7,8}[A-Za-z]$/.test(d[doc].toLowerCase())) {
            this.loginForm.setErrors(null);
            this.formatInvalid = false;
          } else {
            this.loginForm.setErrors({ formatNotValid: true });
            this.formatInvalid = true;
          }
          break;
        case 'N':
        case 'DNI':
        case 'TR':
          if (d[doc] && /^(\d{8})([A-Za-z])$/.test(d[doc].toLowerCase())) {
            if (letras.split('')[+d[doc].substring(0, 8) % 23].toLowerCase() === d[doc].split('')[d[doc].length - 1].toLowerCase()) {
              this.loginForm.setErrors(null);
              this.formatInvalid = false;
            } else {
              this.loginForm.setErrors({ formatNotValid: false });
              this.formatInvalid = true;
            }
          } else {
            this.loginForm.setErrors({ formatNotValid: true });
            this.formatInvalid = true;
          }
          break;
        case 'A':
        case 'ODE':
          if (d[doc] && d[doc].length > 3) {
            this.loginForm.setErrors(null);
            this.formatInvalid = false;
          } else {
            this.loginForm.setErrors({ formatNotValid: true });
            this.formatInvalid = true;
          }
          break;
      }
    });
  }
}
